module.exports = __webpack_public_path__ + "media/packs/images/flags/LY-ad7f3275e87164eed88362effea3e310.png";